import { Condition } from "@warda/library-ui/interfaces";
import { SECTIONS } from "../constants/sections";
import hasPerms from "./hasPerms";
const getSections = (perms) => {
    return SECTIONS.filter((a) => hasPerms(a.perm, perms, Condition.OR));
};
export default getSections;
